import { useState } from 'react';
import CoWorkingForm from './co-working-form';

import SpeakForm from "./speak-form";

export default function CoWorking({ params }) {
    return (
        <div className="overlay-speak">
            <h1>Co-Working Guest</h1>
            <div className="overlay__content">
                <div className="overlay-speak__left">
                    <div className="overlay-speak__item-outer">
                        <div className="overlay-speak__item">
                            <h2>Call Us</h2>
                            <p>+44 (0)1226 720700</p>
                        </div>
                        <div className="overlay-speak__item">
                            <h2>Email Us</h2>
                            <p>dmc@barnsley.gov.uk</p>
                        </div>
                    </div>
                    <div className="overlay-speak__item">
                        <h2>Visit Us</h2>
                        <div className="utils__row">
                           <div className="overlay-speak__column">
                                <p>DMC</p>
                                <p>County Way</p>
                                <p>Barnsley</p>
                                <p>S70 2JW</p>
                                <p>England</p>
                           </div>
                           <div className="overlay-speak__column">

                           </div>
                        </div>
                    </div>
                </div>
                <div className="overlay-speak__right">
                    <form>
                        <CoWorkingForm params={params}/>
                    </form>
                </div>
            </div>
        </div>
    )
}
